import React from 'react'

export default () => {
  return (
    <div
      style={{
        background: 'rgba(255,255,255,.5)',
        position: 'fixed',
        top: 0,
        left:0,
        width: '100%',
        height: '100%',
        zIndex: 666,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        className="spinner"
        style={{
          width: '28px',
          height: '28px'
        }}
      />
    </div>
  )
}
